import React from 'react';

const WebsiteEvaluationSection = ({ websiteEvaluation }) => {
    if (!websiteEvaluation) {
        return null;
    }

    const { 
        score, 
        prose, 
        baseline_score, 
        score_breakdown, 
        negatives, 
        positives, 
        opportunities, 
        performance_findings 
    } = websiteEvaluation;

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Website Evaluation</h4>
            <div style={{
                background: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '16px',
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
            }}>
                {/* Prose */}
                {prose && (
                    <div>
                        <p style={{
                            margin: 0,
                            color: '#d0d0d0',
                            lineHeight: '1.6',
                            fontSize: '14px'
                        }}>
                            {prose}
                        </p>
                    </div>
                )}

                {/* Score Breakdown */}
                {score_breakdown && Array.isArray(score_breakdown) && score_breakdown.length > 0 && (
                    <div>
                        <h5 style={{
                            color: '#e0e0e0',
                            fontSize: '14px',
                            fontWeight: '600',
                            marginBottom: '12px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}>
                            Score Breakdown
                        </h5>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px'
                        }}>
                            {score_breakdown.map((item, index) => (
                                <div key={index} style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '10px 12px',
                                    background: 'rgba(255, 255, 255, 0.03)',
                                    borderRadius: '8px',
                                    border: '1px solid rgba(255, 255, 255, 0.05)'
                                }}>
                                    <span style={{
                                        color: '#d0d0d0',
                                        fontSize: '13px',
                                        flex: 1
                                    }}>
                                        {item.reason}
                                    </span>
                                    <span style={{
                                        color: item.impact > 0 ? '#34d399' : item.impact < 0 ? '#f87171' : '#9ca3af',
                                        fontSize: '13px',
                                        fontWeight: '600',
                                        marginLeft: '12px'
                                    }}>
                                        {item.impact > 0 ? '+' : ''}{item.impact}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                {/* Negatives and Positives */}
                {(negatives?.length > 0 || positives?.length > 0) && (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '16px'
                    }}>
                        {negatives && negatives.length > 0 && (
                            <div>
                                <h5 style={{
                                    color: '#f87171',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    marginBottom: '10px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Negatives
                                </h5>
                                <ul style={{
                                    margin: 0,
                                    paddingLeft: '20px',
                                    color: '#d0d0d0',
                                    fontSize: '13px',
                                    lineHeight: '1.8'
                                }}>
                                    {negatives.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        {positives && positives.length > 0 && (
                            <div>
                                <h5 style={{
                                    color: '#34d399',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    marginBottom: '10px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Positives
                                </h5>
                                <ul style={{
                                    margin: 0,
                                    paddingLeft: '20px',
                                    color: '#d0d0d0',
                                    fontSize: '13px',
                                    lineHeight: '1.8'
                                }}>
                                    {positives.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                )}

                {/* Opportunities */}
                {opportunities && Array.isArray(opportunities) && opportunities.length > 0 && (
                    <div>
                        <h5 style={{
                            color: '#fbbf24',
                            fontSize: '13px',
                            fontWeight: '600',
                            marginBottom: '10px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}>
                            Opportunities
                        </h5>
                        <ul style={{
                            margin: 0,
                            paddingLeft: '20px',
                            color: '#d0d0d0',
                            fontSize: '13px',
                            lineHeight: '1.8'
                        }}>
                            {opportunities.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                )}

                {/* Performance Findings */}
                {performance_findings && Array.isArray(performance_findings) && performance_findings.length > 0 && (
                    <div>
                        <h5 style={{
                            color: '#60a5fa',
                            fontSize: '13px',
                            fontWeight: '600',
                            marginBottom: '10px',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                        }}>
                            Performance Findings
                        </h5>
                        <ul style={{
                            margin: 0,
                            paddingLeft: '20px',
                            color: '#d0d0d0',
                            fontSize: '13px',
                            lineHeight: '1.8'
                        }}>
                            {performance_findings.map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WebsiteEvaluationSection;

